/** Время работы сервера по частям (ADM-UC-1): дни, часы, минуты. */
export function uptimeParts(seconds: number): { d: number; h: number; m: number } {
  const total = Math.max(0, Math.floor(seconds / 60));
  return { d: Math.floor(total / 1440), h: Math.floor((total % 1440) / 60), m: total % 60 };
}
